import SimpleLightbox from "../Helpers/SimpleLightbox";

if (globalThis.jQuery && globalThis.jQuery.fn && !globalThis.jQuery.fn.colorbox) {
    globalThis.jQuery.fn.colorbox = function () {
        var elems = this.get();
        if (elems.length) {
            new SimpleLightbox(elems, {
                history: false,
                fileExt: null
            });
        }
        return this;
    };
}